<template>
  <BreadCrumb :model="getBreadcrumbItems()" />
</template>

<script setup>
import BreadCrumb from '@atomic-ui/breadcrumb/Breadcrumb';
import { WALLET, brand } from 'config';

const props = defineProps({
  currentPage: {
    type: String,
    required: true,
  },
});

const getBreadcrumbItems = () => {
  switch (props.currentPage) {
    case 'Profile':
      return [
        {
          label: 'My Account',
          to: '/myaccount/home',
        },
        {
          label: 'Profile',
          to: '',
        },
      ];
    case 'GiftCardBalance':
      return [
        {
          label: 'My Account',
          to: '/myaccount/home',
        },
        {
          label: WALLET.menuLabel,
          url: brand == 'mcom' ? '/account/wallet?ocwallet=true' : '/account/wallet',
        },
        {
          label: 'Gift Card Balance',
          to: '',
        },
      ];
    default:
      return [
        {
          label: 'My Account',
          to: '/myaccount/home',
        },
      ];
  }
};
</script>
